import { TweenMax } from "gsap";
import { Geometry, HorizontalAlign, Log, Rect, Size, VerticalAlign } from ".././MyHelpers";
import { ITrack } from "../AudioManager";
import { ZIndex } from "../ZIndex";
import { SlotGameBet } from "../api";
import { MyCanvas } from "./MyCanvas";
import { Sprite } from "./Sprite/Sprite";

export interface IWinMessage
{
	name: string;
	winMultiplier: number;
	file: string;
}

export class WinMessage
{
	public name: string;
	public sprite: Sprite;
	public minCreditMultiplier: number;
	public audioTrack: ITrack = null;

	public constructor(name: string, sprite: Sprite, minCreditMultiplier: number, audioTrack: ITrack) {
		this.name = name;
		this.sprite = sprite;
		this.minCreditMultiplier = minCreditMultiplier;
		this.audioTrack = audioTrack;
	}
}

export class WinMessageAnimation
{
	private screenSize: Size = null;
	private canvas: MyCanvas = null;

	private winMessages: WinMessage[] = [];

	private running: boolean = false;
	private runningMessage: WinMessage = null;


	private anim_zoomIn: any;	// TweenMax
	public myscale: number = 0;

	private logGroup: string = "WinMessageAnimation";

	public constructor(screenSize: Size) {
		this.screenSize = screenSize;
		this.canvas = new MyCanvas(screenSize);

		this.canvas.view.classList.add("WinMessageAnimation");

		this.canvas.view.style.position = "absolute";
		this.canvas.view.style.top = "0px";
		this.canvas.view.style.left = "0px";
		this.canvas.view.style.pointerEvents = "none";
		this.canvas.view.style.visibility = "none"; // default hidden
		this.canvas.view.style.zIndex=ZIndex.WinCount.toString();
		this.anim_zoomIn = TweenMax.fromTo(this, 1, {myscale: 0}, {myscale: 0.8, paused: true});
	}

	// make sure messages are added smallest to biggest
	public AddMessage(winMessage: WinMessage) {
		if (this.winMessages.length > 0 && 
			this.winMessages[this.winMessages.length -1].minCreditMultiplier > winMessage.minCreditMultiplier
		)
		{
			Log.Error(this.logGroup, "Make sure win messages are added from smallest to biggest");
		}

		this.winMessages.push(winMessage);
	}

	public WillTrigger(bet: SlotGameBet, winCredit: number): boolean {
		
		let winMultiplier = winCredit / bet.TotalBetCredits;

		// smallest win message is first, co we can check just this one
		if (this.winMessages.length > 0 &&
			this.winMessages[0].minCreditMultiplier <= winMultiplier) {
			return true;
		}

		return false;
	}

	public Start(bet: SlotGameBet, winCredit: number): boolean {
		let winMultiplier = winCredit / bet.TotalBetCredits;
		// find message to run
		// the message is first one, that has lower min threshold than win credit
		// find it by running backwards, so we get the biggest, that satisfies criteria
		let messageToRun: WinMessage = null;
		for (let i = this.winMessages.length -1; i >= 0; i--) {
			if (winMultiplier >= this.winMessages[i].minCreditMultiplier) {
				messageToRun = this.winMessages[i];
				break;
			}
		}

		if (messageToRun != null) {
			this.runningMessage = messageToRun;
			this.runningMessage.sprite.Start(false);

			if (this.runningMessage.audioTrack != null)
			{
				this.runningMessage.audioTrack.Play();
			}

			this.running = true;
		}

		this.anim_zoomIn.restart();
		this.canvas.view.style.visibility = "visible";

		return this.running;
	}

	public IsRunning(): boolean {
		return this.running;
	}

	public Stop() {
		this.running = false;
		this.anim_zoomIn.kill();
		this.canvas.view.style.visibility = "hidden";


/*
		if (this.runningMessage!= null && 
			this.runningMessage.audioTrack != null)
		{
			this.runningMessage.audioTrack.Stop();
		}
*/
	}

	public Update() {
		if (this.running) {
			this.runningMessage.sprite.Update();

			//if (this.runningMessage.sprite.FrameChanged() ) {
				let dstRect = Geometry.FitRect(this.runningMessage.sprite.CurrentFrameRect, Rect.FromSize(this.screenSize), HorizontalAlign.Center, VerticalAlign.Center);
				

				//this.canvas.context.save();

				// applied in reverse order
				this.canvas.context.resetTransform();
				this.canvas.Clear();
				this.canvas.context.translate(0.5 * dstRect.width, 0.5 * dstRect.height);
				this.canvas.context.scale(0.5, 0.5);
				this.canvas.context.translate(-0.5 * dstRect.width, -0.5 * dstRect.height);

				this.runningMessage.sprite.Update();
				this.canvas.DrawImage(this.runningMessage.sprite.CurrentFrame, this.runningMessage.sprite.CurrentFrameRect, dstRect);
				//this.canvas.Canvas()
				//this.canvas.context.restore();
			//}
		}
	}

	public View() {
		return this.canvas.view;
	}
}